const parseYoutubeLink = originalUrl => {
  const url = new URL(originalUrl);
  const params = new URLSearchParams(url.search);
  params.delete('list');
  url.search = params.toString();
  return url.toString();
};

export default parseYoutubeLink;
